import React from "react";
import './SecviveSlider.css';
import Carousel from 'react-bootstrap/Carousel';
import { Link } from "react-router-dom";

function SecviveSlider (){


    return(
        <div className="SecviveSlider">
            <div className="container">
                <div className="content col-lg-4 col-sm-12">
                    <h4>Services</h4>
                    <h2>We Cover A Big Variety Of Medical Services</h2>
                    <p>We provide the special tips and advice’s of heath care treatment and high level of best.</p>
                    <Link to="/service" ><button>All Services</button></Link>
                </div>
                 <div className="cards col-lg-3 col-sm-12">
                    <Carousel indicators={false} controls={false}>
                        <Carousel.Item>
                            <div className="card">
                                <div className="image"><i class="fa-solid fa-stethoscope"></i></div>
                                <h3>Diagnostics</h3>
                                <p>Phasellus venenatis porta rhoncus. Integer et viverra felis.</p>
                                <Link to="/service" ><button>View More</button></Link>
                            </div>
                        </Carousel.Item>
                        <Carousel.Item>
                            <div className="card">
                                <div className="image"><i class="fa-solid fa-syringe"></i></div>
                                <h3>Treatment</h3>
                                <p>Phasellus venenatis porta rhoncus. Integer et viverra felis.</p>
                                <Link to="/service" ><button>View More</button></Link>
                            </div>
                        </Carousel.Item>
                        <Carousel.Item>
                            <div className="card">
                                <div className="image"><i class="fa-solid fa-hospital"></i></div>
                                <h3>Surgery</h3>
                                <p>Phasellus venenatis porta rhoncus. Integer et viverra felis.</p>
                                <Link to="/service" ><button>View More</button></Link>
                            </div> 
                        </Carousel.Item>
                    </Carousel>
                    <Carousel indicators={false} controls={false}>
                        <Carousel.Item>
                            <div className="card">
                                <div className="image"><i class="fa-solid fa-user-doctor"></i></div>
                                <h3>Qualified Doctors</h3>
                                <p>Phasellus venenatis porta rhoncus. Integer et viverra felis.</p>
                                <Link to="/service" ><button>View More</button></Link>
                            </div>
                        </Carousel.Item>
                        <Carousel.Item>
                            <div className="card">
                                <div className="image"><i class="fa-solid fa-vial-circle-check"></i></div>
                                <h3>Vaccine</h3>
                                <p>Phasellus venenatis porta rhoncus. Integer et viverra felis.</p>
                                <Link to="/service" ><button>View More</button></Link>
                            </div>
                        </Carousel.Item>
                        <Carousel.Item>
                            <div className="card">
                                <div className="image"><i class="fa-solid fa-truck-medical"></i></div>
                                <h3>Emergency</h3>
                                <p>Phasellus venenatis porta rhoncus. Integer et viverra felis.</p>
                                <Link to="/service" ><button>View More</button></Link>
                            </div>
                        </Carousel.Item>
                    </Carousel>
                </div>
            </div>
        </div>
    )
}
export default SecviveSlider